export default __webpack_public_path__ + "static/Service_Brows_Icon-ef145ec5d60d2ab30e804c2a916dbafd.svg";